(function () {
  'use strict';

  var STORAGE_KEY = 'zk_delivery_location_v2';
  var SESSION_KEY = 'zk_delivery_detected_v2';
  var LOCATION_DATA_KEY = 'zk_colombia_locations_v2';
  var TIME_ZONE = 'America/Bogota';
  var LOCATION_TTL = 1000 * 60 * 60 * 24 * 45;
  var LOCATION_DATA_TTL = 1000 * 60 * 60 * 24 * 30;
  var DETECTION_TIMEOUT = 4500;
  var CUTOFF_MINUTES = (14 * 60) + 30;
  var OFFICIAL_LOCATIONS_URL = 'https://www.datos.gov.co/resource/gdxc-w37w.json?$limit=5000';
  var FALLBACK_DEPARTMENTS_URL = 'https://raw.githubusercontent.com/proyecto26/colombia/master/departments.json';
  var FALLBACK_CITIES_URL = 'https://raw.githubusercontent.com/proyecto26/colombia/master/cities.json';

  var mainCities = [
    'medellin', 'cali', 'barranquilla', 'cartagena', 'bucaramanga',
    'pereira', 'manizales', 'armenia', 'cucuta', 'santa marta',
    'villavicencio', 'ibague', 'neiva', 'tunja', 'pasto', 'monteria',
    'valledupar', 'sincelejo', 'popayan'
  ];

  var state = {
    location: null,
    detecting: false,
    initialized: false,
    timer: null,
    modalReturnFocus: null,
    locationOptions: [],
    mainLocationOptions: [],
    locationOptionsPromise: null,
    locationOptionsLoaded: false
  };

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function titleCase(value) {
    var smallWords = { de: true, del: true, la: true, las: true, los: true, y: true, e: true, el: true, en: true, al: true };
    return String(value || '').trim().toLowerCase().split(/\s+/).map(function (word, index) {
      return word.split('-').map(function (part, partIndex) {
        if (!part) return part;
        if ((index > 0 || partIndex > 0) && smallWords[part]) return part;
        return part.charAt(0).toUpperCase() + part.slice(1);
      }).join('-');
    }).join(' ').replace(/D\.c\./g, 'D.C.');
  }

  function canonicalCity(city) {
    var cleaned = normalize(city);
    if (!cleaned) return '';
    if (cleaned.indexOf('bogota') !== -1 || cleaned.indexOf('distrito capital') !== -1) return 'Bogotá';
    if (cleaned.indexOf('soacha') !== -1) return 'Soacha';
    if (cleaned === 'medellin') return 'Medellín';
    if (cleaned === 'cali' || cleaned.indexOf('santiago de cali') !== -1) return 'Cali';
    if (cleaned === 'cucuta' || cleaned.indexOf('san jose de cucuta') !== -1) return 'Cúcuta';
    if (cleaned === 'ibague') return 'Ibagué';
    if (cleaned === 'monteria') return 'Montería';
    if (cleaned === 'popayan') return 'Popayán';
    return titleCase(city);
  }

  function classifyCity(city) {
    var cleaned = normalize(city);
    if (!cleaned) return 'unknown';
    if (cleaned.indexOf('bogota') !== -1 || cleaned.indexOf('distrito capital') !== -1) return 'bogota';
    if (cleaned.indexOf('soacha') !== -1) return 'soacha';
    if (mainCities.some(function (item) { return cleaned === item || cleaned.indexOf(item) !== -1; })) return 'main';
    return 'other';
  }

  function safeJsonParse(value) {
    try { return JSON.parse(value); } catch (error) { return null; }
  }

  function readStoredLocation() {
    var stored = safeJsonParse(window.localStorage.getItem(STORAGE_KEY));
    if (stored && stored.city && stored.savedAt && (Date.now() - stored.savedAt) < LOCATION_TTL) {
      stored.confirmed = true;
      return stored;
    }
    if (stored) window.localStorage.removeItem(STORAGE_KEY);

    var detected = safeJsonParse(window.sessionStorage.getItem(SESSION_KEY));
    if (detected && detected.city) {
      detected.confirmed = false;
      return detected;
    }
    return null;
  }

  function saveLocation(location, confirmed) {
    var value = {
      city: canonicalCity(location.city),
      region: location.region || '',
      countryCode: location.countryCode || 'CO',
      zone: classifyCity(location.city),
      source: location.source || 'manual',
      confirmed: Boolean(confirmed),
      savedAt: Date.now()
    };
    if (confirmed) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
      window.sessionStorage.removeItem(SESSION_KEY);
    } else {
      window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(value));
    }
    state.location = value;
  }

  function getBogotaParts(date) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIME_ZONE,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(date || new Date());
    var result = {};
    parts.forEach(function (part) { if (part.type !== 'literal') result[part.type] = Number(part.value); });
    return result;
  }

  function bogotaWallDate(date) {
    var p = getBogotaParts(date);
    return new Date(Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second));
  }

  function dateKey(date) {
    return [date.getUTCFullYear(), String(date.getUTCMonth() + 1).padStart(2, '0'), String(date.getUTCDate()).padStart(2, '0')].join('-');
  }

  function addDays(date, days) {
    var copy = new Date(date.getTime());
    copy.setUTCDate(copy.getUTCDate() + days);
    return copy;
  }

  function nextOrSameMonday(date) {
    var day = date.getUTCDay();
    return addDays(date, day === 1 ? 0 : ((8 - day) % 7));
  }

  function easterSunday(year) {
    var a = year % 19, b = Math.floor(year / 100), c = year % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(year, month - 1, day));
  }

  function colombianHolidays(year) {
    var set = new Set();
    function fixed(month, day) { set.add(dateKey(new Date(Date.UTC(year, month - 1, day)))); }
    function mondayHoliday(month, day) { set.add(dateKey(nextOrSameMonday(new Date(Date.UTC(year, month - 1, day))))); }
    fixed(1, 1); mondayHoliday(1, 6); mondayHoliday(3, 19); fixed(5, 1);
    mondayHoliday(6, 29); mondayHoliday(7, 9); fixed(7, 20); fixed(8, 7);
    mondayHoliday(8, 15); mondayHoliday(10, 12); mondayHoliday(11, 1); mondayHoliday(11, 11);
    fixed(12, 8); fixed(12, 25);
    var easter = easterSunday(year);
    set.add(dateKey(addDays(easter, -3))); set.add(dateKey(addDays(easter, -2)));
    set.add(dateKey(nextOrSameMonday(addDays(easter, 39))));
    set.add(dateKey(nextOrSameMonday(addDays(easter, 60))));
    set.add(dateKey(nextOrSameMonday(addDays(easter, 68))));
    return set;
  }

  var holidayCache = {};
  function isHoliday(date) {
    var year = date.getUTCFullYear();
    if (!holidayCache[year]) holidayCache[year] = colombianHolidays(year);
    return holidayCache[year].has(dateKey(date));
  }
  function isOperationalDay(date) { return date.getUTCDay() !== 0 && !isHoliday(date); }
  function isNationalBusinessDay(date) { var day = date.getUTCDay(); return day >= 1 && day <= 5 && !isHoliday(date); }
  function nextOperationalDate(fromDate) {
    var candidate = addDays(fromDate, 1), guard = 0;
    while (!isOperationalDay(candidate) && guard < 20) { candidate = addDays(candidate, 1); guard += 1; }
    return candidate;
  }
  function addBusinessDays(fromDate, count) {
    var candidate = new Date(fromDate.getTime()), counted = 0, guard = 0;
    while (counted < count && guard < 40) {
      candidate = addDays(candidate, 1);
      if (isNationalBusinessDay(candidate)) counted += 1;
      guard += 1;
    }
    return candidate;
  }
  function minutesOfDay(date) { return (date.getUTCHours() * 60) + date.getUTCMinutes(); }
  function sameDayStatus(now) {
    var sameDay = isOperationalDay(now) && minutesOfDay(now) < CUTOFF_MINUTES;
    if (sameDay) {
      var cutoff = new Date(now.getTime()); cutoff.setUTCHours(14, 30, 0, 0);
      return { sameDay: true, target: now, remainingMinutes: Math.max(1, Math.ceil((cutoff.getTime() - now.getTime()) / 60000)) };
    }
    return { sameDay: false, target: nextOperationalDate(now), remainingMinutes: 0 };
  }
  function formatCountdown(minutes) {
    if (minutes < 60) return minutes + ' min';
    var hours = Math.floor(minutes / 60), rest = minutes % 60;
    return rest ? hours + ' h ' + rest + ' min' : hours + ' h';
  }
  function formatShortDate(target) {
    return new Intl.DateTimeFormat('es-CO', { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(target).replace(/,/g, '');
  }
  function formatDeliveryDate(target, now) {
    var today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    var delivery = new Date(Date.UTC(target.getUTCFullYear(), target.getUTCMonth(), target.getUTCDate()));
    var diff = Math.round((delivery.getTime() - today.getTime()) / 86400000);
    var dateText = formatShortDate(delivery);
    if (diff === 0) return 'hoy';
    if (diff === 1) return 'mañana, ' + dateText;
    return 'el ' + dateText;
  }

  function getSelectedVariant(block) {
    var productRoot = block.closest('.product');
    if (!productRoot) return null;
    var raw = productRoot.querySelector('variant-selects [data-selected-variant]');
    var parsed = raw ? safeJsonParse(raw.textContent.trim()) : null;
    if (parsed) return parsed;
    return null;
  }

  function buildPromise(location, available) {
    var now = bogotaWallDate();
    if (!location || !location.city || location.zone === 'unknown') {
      return {
        locationLabel: 'Entrega',
        title: 'Calcula la fecha de entrega',
        detail: 'Ingresa tu ciudad o municipio.',
        zone: 'unknown', unavailable: false
      };
    }

    var city = canonicalCity(location.city);
    var zone = location.zone || classifyCity(location.city);

    if (available === false) {
      return {
        locationLabel: 'Envío a ' + city,
        title: 'No disponible para entrega',
        detail: 'Elige un color disponible para consultar la fecha de entrega.',
        zone: zone, unavailable: true
      };
    }

    if (zone === 'bogota' || zone === 'soacha') {
      var delivery = sameDayStatus(now);
      if (delivery.sameDay) {
        return {
          locationLabel: 'Envío a ' + city,
          title: 'Llega hoy',
          detail: 'Compra en ' + formatCountdown(delivery.remainingMinutes) + ' para programar la entrega de hoy.',
          zone: zone, unavailable: false
        };
      }
      return {
        locationLabel: 'Envío a ' + city,
        title: 'Llega ' + formatDeliveryDate(delivery.target, now),
        detail: 'Fecha estimada según cobertura y confirmación del pedido.',
        zone: zone, unavailable: false
      };
    }

    var businessDays = zone === 'main' ? 2 : 3;
    var target = addBusinessDays(now, businessDays);
    return {
      locationLabel: 'Envío a ' + city,
      title: 'Llega aprox. ' + formatDeliveryDate(target, now),
      detail: zone === 'main' ? 'Entrega estimada de 1 a 3 días hábiles.' : 'Entrega estimada de 2 a 4 días hábiles.',
      zone: zone, unavailable: false
    };
  }

  function renderBlocks() {
    document.querySelectorAll('[data-zk-delivery-promise]').forEach(function (block) {
      var variant = getSelectedVariant(block);
      var available = variant ? variant.available !== false : true;
      var promise = buildPromise(state.location, available);
      var locationNode = block.querySelector('[data-zk-delivery-location]');
      var titleNode = block.querySelector('[data-zk-delivery-title]');
      var detailNode = block.querySelector('[data-zk-delivery-detail]');
      var confirmNode = block.querySelector('[data-zk-location-confirm]');
      var confirmCopy = block.querySelector('[data-zk-location-confirm-copy]');
      var changeNode = block.querySelector('[data-zk-location-change]');

      if (locationNode) locationNode.textContent = promise.locationLabel;
      if (titleNode) titleNode.textContent = promise.title;
      if (detailNode) detailNode.textContent = promise.detail;
      if (confirmNode) confirmNode.hidden = !(state.location && !state.location.confirmed);
      if (confirmCopy && state.location && !state.location.confirmed) confirmCopy.textContent = '¿Estás en ' + canonicalCity(state.location.city) + '?';
      if (changeNode) changeNode.textContent = promise.zone === 'unknown' ? 'Ingresar ubicación' : 'Cambiar ubicación';
      block.classList.toggle('zk-delivery-promise--unknown', promise.zone === 'unknown');
      block.classList.toggle('zk-delivery-promise--unavailable', promise.unavailable);
    });
  }

  function setLocation(location, confirmed) {
    saveLocation(location, confirmed);
    renderBlocks();
    document.dispatchEvent(new CustomEvent('zk:location-changed', { detail: state.location }));
  }

  function confirmCurrentLocation() {
    if (!state.location || !state.location.city) return;
    saveLocation(state.location, true);
    renderBlocks();
    closeLocationModal();
  }

  function getModal() { return document.querySelector('[data-zk-location-modal]'); }

  function ensureModalPortal() {
    var modal = getModal();
    if (!modal) return null;
    // Safari/iOS treats position:fixed inside transformed theme containers as local positioning.
    // Move the dialog to <body> so it is always a true viewport overlay, independent of PDP layout.
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    return modal;
  }

  function getLocationInput() { var modal = getModal(); return modal ? modal.querySelector('[data-zk-location-input]') : null; }

  function normalizeLocationEntry(city, region) {
    city = canonicalCity(city); region = titleCase(region || '');
    if (!city) return null;
    if (normalize(city).indexOf('bogota') !== -1) { city = 'Bogotá'; region = 'Bogotá D.C.'; }
    return {
      city: city, region: region, citySearch: normalize(city), regionSearch: normalize(region),
      label: region && normalize(region) !== normalize(city) ? city + ', ' + region : city
    };
  }

  function dedupeLocationOptions(options) {
    var seen = {};
    return options.filter(function (entry) {
      if (!entry || !entry.city) return false;
      var key = normalize(entry.city) + '|' + normalize(entry.region);
      if (seen[key]) return false;
      seen[key] = true; return true;
    }).sort(function (a, b) { return a.label.localeCompare(b.label, 'es', { sensitivity: 'base' }); });
  }

  function getMainCityOptions() {
    if (state.mainLocationOptions.length) return state.mainLocationOptions;
    var modal = getModal(); if (!modal) return [];
    state.mainLocationOptions = Array.prototype.map.call(modal.querySelectorAll('[data-zk-location-city-source] option'), function (option) {
      return normalizeLocationEntry(option.value, option.getAttribute('data-region') || '');
    }).filter(Boolean);
    return state.mainLocationOptions;
  }

  function readCachedLocationOptions() {
    var cached = safeJsonParse(window.localStorage.getItem(LOCATION_DATA_KEY));
    if (!cached || !Array.isArray(cached.items) || !cached.savedAt) return [];
    if ((Date.now() - cached.savedAt) >= LOCATION_DATA_TTL) { window.localStorage.removeItem(LOCATION_DATA_KEY); return []; }
    return cached.items.map(function (entry) { return normalizeLocationEntry(entry.city, entry.region); }).filter(Boolean);
  }
  function cacheLocationOptions(options) {
    try {
      window.localStorage.setItem(LOCATION_DATA_KEY, JSON.stringify({
        savedAt: Date.now(), items: options.map(function (entry) { return { city: entry.city, region: entry.region }; })
      }));
    } catch (error) {}
  }
  function fetchJson(url, timeoutMs) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeout = window.setTimeout(function () { if (controller) controller.abort(); }, timeoutMs || 8000);
    return fetch(url, { method: 'GET', mode: 'cors', cache: 'force-cache', referrerPolicy: 'no-referrer', signal: controller ? controller.signal : undefined })
      .then(function (response) { if (!response.ok) throw new Error('Location data unavailable'); return response.json(); })
      .finally(function () { window.clearTimeout(timeout); });
  }
  function locationsFromOfficialData(rows) {
    if (!Array.isArray(rows)) return [];
    return rows.map(function (row) {
      var city = row.nombre_municipio || row.municipio || row.nom_mpio || row.nombre_del_municipio || row.mpio || row.city || '';
      var region = row.nombre_departamento || row.departamento || row.dpto || row.nombre_del_departamento || row.department || '';
      return normalizeLocationEntry(city, region);
    }).filter(Boolean);
  }
  function locationsFromFallbackData(departmentsPayload, citiesPayload) {
    var departments = departmentsPayload && Array.isArray(departmentsPayload.data) ? departmentsPayload.data : [];
    var cities = citiesPayload && Array.isArray(citiesPayload.data) ? citiesPayload.data : [];
    var departmentMap = {};
    departments.forEach(function (d) { departmentMap[String(d.id)] = d.name || ''; });
    return cities.map(function (city) { return normalizeLocationEntry(city.name, departmentMap[String(city.departmentId)] || ''); }).filter(Boolean);
  }

  function loadLocationOptions() {
    if (state.locationOptionsLoaded) return Promise.resolve(state.locationOptions);
    if (state.locationOptionsPromise) return state.locationOptionsPromise;
    var cached = readCachedLocationOptions();
    if (cached.length > 500) { state.locationOptions = dedupeLocationOptions(cached); state.locationOptionsLoaded = true; return Promise.resolve(state.locationOptions); }

    state.locationOptionsPromise = fetchJson(OFFICIAL_LOCATIONS_URL, 9000)
      .then(function (rows) { var options = locationsFromOfficialData(rows); if (options.length < 500) throw new Error('Incomplete location data'); return options; })
      .catch(function () {
        return Promise.all([fetchJson(FALLBACK_DEPARTMENTS_URL, 9000), fetchJson(FALLBACK_CITIES_URL, 9000)])
          .then(function (payloads) { return locationsFromFallbackData(payloads[0], payloads[1]); });
      })
      .then(function (options) {
        state.locationOptions = dedupeLocationOptions(options.concat(getMainCityOptions()));
        state.locationOptionsLoaded = state.locationOptions.length > 0;
        if (state.locationOptionsLoaded) cacheLocationOptions(state.locationOptions);
        return state.locationOptions;
      })
      .catch(function () { state.locationOptions = getMainCityOptions().slice(); return state.locationOptions; })
      .finally(function () { state.locationOptionsPromise = null; });
    return state.locationOptionsPromise;
  }

  function scoreLocationOption(entry, query) {
    if (!query) return 99;
    if (entry.citySearch === query) return 0;
    if (entry.citySearch.indexOf(query) === 0) return 1;
    if (entry.citySearch.split(' ').some(function (word) { return word.indexOf(query) === 0; })) return 2;
    if (entry.citySearch.indexOf(query) !== -1) return 3;
    if (entry.regionSearch === query) return 4;
    if (entry.regionSearch.indexOf(query) === 0) return 5;
    if (entry.regionSearch.indexOf(query) !== -1) return 6;
    return 99;
  }

  function getCityOptions() { return state.locationOptions.length ? state.locationOptions : getMainCityOptions(); }
  function updateClearButton(input) { var modal = getModal(); var btn = modal && modal.querySelector('[data-zk-location-clear]'); if (btn) btn.hidden = !input || !input.value; }
  function hideSuggestions(input) { var modal = getModal(); var list = modal && modal.querySelector('[data-zk-location-suggestions]'); if (list) list.hidden = true; if (input) input.setAttribute('aria-expanded', 'false'); }

  function renderSuggestions(input) {
    var modal = getModal(); if (!modal || !input) return;
    var list = modal.querySelector('[data-zk-location-suggestions]'); if (!list) return;
    var query = normalize(input.value);
    var options = !query ? getMainCityOptions().slice(0, 12) : getCityOptions().map(function (entry) {
      return { entry: entry, score: scoreLocationOption(entry, query) };
    }).filter(function (item) { return item.score < 99; }).sort(function (a, b) {
      if (a.score !== b.score) return a.score - b.score;
      return a.entry.label.localeCompare(b.entry.label, 'es', { sensitivity: 'base' });
    }).slice(0, 12).map(function (item) { return item.entry; });

    list.innerHTML = '';
    options.forEach(function (entry) {
      var button = document.createElement('button');
      button.type = 'button'; button.className = 'zk-location-modal__suggestion'; button.setAttribute('role', 'option');
      button.setAttribute('data-zk-location-suggestion-city', entry.city); button.setAttribute('data-zk-location-suggestion-region', entry.region || '');
      var strong = document.createElement('strong'); strong.textContent = entry.city; button.appendChild(strong);
      if (entry.region && normalize(entry.region) !== normalize(entry.city)) { var small = document.createElement('small'); small.textContent = entry.region; button.appendChild(small); }
      list.appendChild(button);
    });
    list.hidden = options.length === 0; input.setAttribute('aria-expanded', options.length ? 'true' : 'false'); updateClearButton(input); scheduleViewportUpdate();
  }

  function showSuggestions(input) {
    if (!input) return;
    renderSuggestions(input);
    loadLocationOptions().then(function () { var modal = getModal(); if (modal && !modal.hidden && document.documentElement.contains(input)) renderSuggestions(input); });
  }

  function setModalStatus(message, isError) {
    var modal = getModal(); var status = modal && modal.querySelector('[data-zk-location-status]'); if (!status) return;
    status.textContent = message || ''; status.hidden = !message; status.classList.toggle('zk-location-modal__status--error', Boolean(isError));
  }

  function updateLocationModalViewport() {
    var modal = getModal(); if (!modal) return;
    var viewport = window.visualViewport; var height = viewport ? viewport.height : window.innerHeight;
    modal.style.setProperty('--zk-location-viewport-height', Math.max(240, Math.round(height)) + 'px');
    var input = getLocationInput(); var focused = input && document.activeElement === input;
    if (focused && window.matchMedia('(max-width: 749px)').matches) {
      window.requestAnimationFrame(function () {
        var current = window.visualViewport; var bottom = current ? current.offsetTop + current.height : window.innerHeight;
        var rect = input.getBoundingClientRect();
        modal.style.setProperty('--zk-location-suggestions-height', Math.max(100, Math.floor(bottom - rect.bottom - 12)) + 'px');
      });
    } else modal.style.removeProperty('--zk-location-suggestions-height');
  }
  function scheduleViewportUpdate() { window.requestAnimationFrame(updateLocationModalViewport); window.setTimeout(updateLocationModalViewport, 100); }

  function openLocationModal(trigger) {
    var modal = ensureModalPortal(); if (!modal) return;
    loadLocationOptions(); state.modalReturnFocus = trigger || document.activeElement; modal.hidden = false;
    document.documentElement.classList.add('zk-location-modal-open'); document.body.classList.add('zk-location-modal-open'); setModalStatus('', false); scheduleViewportUpdate();
    var input = getLocationInput(); if (input) {
      input.value = state.location && state.location.city ? state.location.city : ''; updateClearButton(input); hideSuggestions(input);
      if (!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches)) window.setTimeout(function () { input.focus({ preventScroll: true }); if (input.value) input.select(); showSuggestions(input); }, 50);
    }
  }

  function closeLocationModal() {
    var modal = getModal(); if (!modal || modal.hidden) return;
    hideSuggestions(getLocationInput()); modal.hidden = true; document.documentElement.classList.remove('zk-location-modal-open'); document.body.classList.remove('zk-location-modal-open');
    if (state.modalReturnFocus && typeof state.modalReturnFocus.focus === 'function') state.modalReturnFocus.focus();
  }

  function detectByIp() {
    if (state.detecting || state.location) return Promise.resolve(state.location);
    state.detecting = true;
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeout = window.setTimeout(function () { if (controller) controller.abort(); }, DETECTION_TIMEOUT);
    return fetch('https://ipapi.co/json/', { method: 'GET', mode: 'cors', cache: 'no-store', referrerPolicy: 'no-referrer', signal: controller ? controller.signal : undefined })
      .then(function (response) { if (!response.ok) throw new Error('Location unavailable'); return response.json(); })
      .then(function (data) {
        if (!data || !data.city || (data.country_code && data.country_code !== 'CO')) throw new Error('Location not found');
        setLocation({ city: data.city, region: data.region || '', countryCode: data.country_code || 'CO', source: 'ip' }, false);
        return state.location;
      }).catch(function () { renderBlocks(); return null; }).finally(function () { window.clearTimeout(timeout); state.detecting = false; });
  }

  function reverseGeocode(latitude, longitude) {
    var url = 'https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=' + encodeURIComponent(latitude) + '&longitude=' + encodeURIComponent(longitude) + '&localityLanguage=es';
    return fetch(url, { method: 'GET', mode: 'cors', cache: 'no-store', referrerPolicy: 'no-referrer' })
      .then(function (response) { if (!response.ok) throw new Error('Reverse geocoding unavailable'); return response.json(); })
      .then(function (data) {
        var city = data.city || data.locality || data.principalSubdivision; if (!city) throw new Error('City not found');
        return { city: city, region: data.principalSubdivision || '', countryCode: data.countryCode || 'CO', source: 'gps' };
      });
  }

  function useDeviceLocation(button) {
    if (!navigator.geolocation) { setModalStatus('Tu navegador no permite usar la ubicación. Escribe tu ciudad.', true); return; }
    button.disabled = true; setModalStatus('Identificando tu ciudad…', false);
    navigator.geolocation.getCurrentPosition(function (position) {
      reverseGeocode(position.coords.latitude, position.coords.longitude).then(function (location) { setLocation(location, true); closeLocationModal(); })
        .catch(function () { setModalStatus('No pudimos identificar la ciudad. Escríbela para continuar.', true); })
        .finally(function () { button.disabled = false; });
    }, function () { button.disabled = false; setModalStatus('No fue posible usar la ubicación. Puedes escribir tu ciudad.', true); }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 300000 });
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var suggestion = event.target.closest('[data-zk-location-suggestion-city]');
      if (suggestion) {
        event.preventDefault(); setLocation({ city: suggestion.getAttribute('data-zk-location-suggestion-city'), region: suggestion.getAttribute('data-zk-location-suggestion-region') || '', source: 'manual', countryCode: 'CO' }, true); closeLocationModal(); return;
      }
      var clear = event.target.closest('[data-zk-location-clear]');
      if (clear) { event.preventDefault(); var input = getLocationInput(); if (input) { input.value = ''; updateClearButton(input); input.focus(); showSuggestions(input); } return; }
      var change = event.target.closest('[data-zk-location-change], [data-zk-location-confirm-change]');
      if (change) { event.preventDefault(); openLocationModal(change); return; }
      var confirm = event.target.closest('[data-zk-location-confirm-yes]');
      if (confirm) { event.preventDefault(); confirmCurrentLocation(); return; }
      var close = event.target.closest('[data-zk-location-close]');
      if (close) { event.preventDefault(); closeLocationModal(); return; }
      var gps = event.target.closest('[data-zk-location-gps]');
      if (gps) { event.preventDefault(); useDeviceLocation(gps); return; }
      var manualInput = event.target.closest('[data-zk-location-input]');
      if (manualInput) { showSuggestions(manualInput); scheduleViewportUpdate(); }
    });

    document.addEventListener('input', function (event) {
      if (event.target.matches('[data-zk-location-input]')) { updateClearButton(event.target); showSuggestions(event.target); setModalStatus('', false); }
    });
    document.addEventListener('focusin', function (event) { if (event.target.matches('[data-zk-location-input]')) { showSuggestions(event.target); scheduleViewportUpdate(); } });
    document.addEventListener('focusout', function (event) {
      if (!event.target.matches('[data-zk-location-input]')) return;
      window.setTimeout(function () { var modal = getModal(); if (!modal || !modal.contains(document.activeElement)) hideSuggestions(event.target); }, 140);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-zk-location-form]'); if (!form) return;
      event.preventDefault(); var input = form.querySelector('[data-zk-location-input]'); var city = input ? input.value.trim() : '';
      if (!city || city.length < 2) { setModalStatus('Escribe una ciudad o municipio válido.', true); if (input) input.focus(); return; }
      var q = normalize(city); var exact = getCityOptions().filter(function (entry) { return entry.citySearch === q || normalize(entry.label) === q; });
      if (exact.length > 1) { setModalStatus('Selecciona el municipio y departamento correctos en la lista.', true); showSuggestions(input); return; }
      var matched = exact.length === 1 ? exact[0] : null;
      setLocation({ city: matched ? matched.city : city, region: matched ? matched.region : '', source: 'manual', countryCode: 'CO' }, true); closeLocationModal();
    });

    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeLocationModal(); });
    document.addEventListener('shopify:section:load', function () { window.setTimeout(renderBlocks, 80); });
    window.addEventListener('resize', scheduleViewportUpdate, { passive: true });
    if (window.visualViewport) { window.visualViewport.addEventListener('resize', scheduleViewportUpdate, { passive: true }); window.visualViewport.addEventListener('scroll', scheduleViewportUpdate, { passive: true }); }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { window.setTimeout(renderBlocks, 0); window.setTimeout(renderBlocks, 120); });
    }
    document.addEventListener('variant:change', function () { window.setTimeout(renderBlocks, 0); });
  }

  function startRefreshTimer() {
    if (state.timer) { window.clearInterval(state.timer); state.timer = null; }
    if (document.hidden) return;
    state.timer = window.setInterval(renderBlocks, 30000);
  }

  function init() {
    if (state.initialized || !document.querySelector('[data-zk-delivery-promise]')) return;
    state.initialized = true; state.location = readStoredLocation(); ensureModalPortal(); bindEvents(); renderBlocks();
    if (!state.location) {
      var target = document.querySelector('[data-zk-delivery-promise]');
      var requestDetection = function () {
        if (state.location || document.hidden) return;
        var run = function () { if (!state.location) detectByIp(); };
        if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 3500 }); else window.setTimeout(run, 1800);
      };
      if (target && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) { if (!entries.some(function (entry) { return entry.isIntersecting; })) return; observer.disconnect(); requestDetection(); }, { rootMargin: '0px 0px 80px 0px' });
        observer.observe(target);
      } else requestDetection();
    }
    startRefreshTimer();
    document.addEventListener('visibilitychange', function () { if (!document.hidden) renderBlocks(); startRefreshTimer(); });
  }

  window.ZaesKidsDelivery = {
    getState: function () { return { location: state.location ? Object.assign({}, state.location) : null }; },
    openLocation: openLocationModal,
    render: renderBlocks,
    confirmLocation: confirmCurrentLocation,
    _test: { easterSunday: easterSunday, colombianHolidays: colombianHolidays, addBusinessDays: addBusinessDays, sameDayStatus: sameDayStatus, buildPromise: buildPromise, classifyCity: classifyCity }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
